import type { Settings } from '@quromedical/models';
import { CrudForm } from 'components/form';
import type { Field } from 'components/types';
import type { FormikErrors } from 'formik';
import type React from 'react';
import { useCallback } from 'react';
import { strings } from 'strings';

interface PractitionerSettingsFormProps {
  onValidChange: (data?: Settings) => void;
  showErrors: boolean;
}

export const settingsFields = (): Field<Settings>[] => {
  return [
    {
      subfields: [
        {
          type: 'combobox-single',
          label: strings.FormLabelPractitionerCanPrescribe,
          key: 'canPrescribe',
          fetcher: [
            { display: 'Yes', value: true },
            { display: 'No', value: false },
          ],
        },
      ],
    },
  ];
};

export const PractitionerSettingsForm: React.FC<
  PractitionerSettingsFormProps
> = ({ onValidChange, showErrors }) => {
  const fields = settingsFields();

  const onChange = useCallback(
    (
      data: Partial<Settings>,
      _: FormikErrors<Settings>,
      hasErrors: boolean,
    ) => {
      if (hasErrors) {
        onValidChange(undefined);
      } else {
        // casting since data is validated
        const result = data as Settings;

        onValidChange(result);
      }
    },
    [onValidChange],
  );

  return (
    <CrudForm
      title={strings.FormLabelPractitionerCanPrescribeSettings}
      fields={fields}
      initialValues={{}}
      onChange={onChange}
      showErrors={showErrors}
      validateOnMount
      showSubmitButton={false}
      hasCard={false}
    />
  );
};
